import React, {Component} from "react";
import {t} from "./t";

export class Loading extends Component<any, any> {
    render() {
        return <>{t('Loading...')}</>;
    }
}